/* lkp2-auto.js - Lush Keepsake personaliser: guided auto-advance between steps.
   24/10/2026: the customer is in control - nothing moves on, scrolls or focuses by itself. When a step is
   complete the Next button is outlined in gold; the next thing to fill in gets a gold outline.
   Enter on a text box goes to the next empty box; on the last one it closes the keyboard. */
(function () {
  'use strict';
  if (!window.LKP2 || !window.LKP2.P || window.__lkp2Auto) return;
  window.__lkp2Auto = 1;
  var P = window.LKP2.P, DELAY = 1100, timer = null, bar = null, fromStep = null, focusVal = null;
  var fine = window.matchMedia && window.matchMedia('(pointer:fine)').matches;

  function me() { try { return window.LKP2.get(); } catch (e) { return null; } }
  function modal() { return document.querySelector('.lkp2.lkp2--modal.is-open'); }
  function openPanel(m) { return m && m.querySelector('.lkp2__panel.is-open'); }
  function curFace(x) { var s = x && x.st && x.st.step; return s && s !== 'finish' && s !== 'review' ? x.face(s) : null; }

  // a real choice of sides: more than one to engrave and fewer than all of them (all sides = nothing to choose)
  function multiPick(x) { var ci = x.countInfo && x.countInfo(); return !!(ci && ci.pick && ci.n > 1 && ci.n < ci.counted.length); }
  function finishDone(x) {
    if (!x.colourIsVariant && (x.cfg.colours || []).length > 1 && !x.colour()) return false;
    var ci = x.countInfo && x.countInfo();
    if (ci && ci.pick && ci.n && (x.st.picked || []).length !== ci.n) return false;
    // More than one side to engrave: let the customer confirm which sides before moving on.
    if (multiPick(x) && !x._autoChips) return false;
    return true;
  }
  function faceDone(x, f) {
    if (!f) return false;
    if (f.sameAs && x.st.same && x.st.same[f.id]) return true;
    if (!x.hasContent(f)) return false;
    var V = x.vals(f) || {}, ok = true;
    x.fieldsOf(f).forEach(function (fd) {
      if (!ok || fd.type === 'font' || fd.type === 'icon' || fd.type === 'upload') return;
      if (fd.type === 'select') {
        var so = x.selOption(f, fd);
        if (!so) { if (fd.required !== false) ok = false; return; }
        (so.fields || []).forEach(function (sf) { if (sf.required && !V[fd.id + '.' + sf.id]) ok = false; });
        return;
      }
      if (fd.required && !V[fd.id]) ok = false;
    });
    if (x.planErr && x.planErr[f.id]) ok = false;
    return ok;
  }
  function stepDone(x) {
    var s = x.st.step;
    if (s === 'finish') return finishDone(x);
    if (s === 'review') return false;
    return faceDone(x, curFace(x));
  }
  function nextLabel(x) {
    var st = x.steps(), i = st.indexOf(x.st.step), nx = st[i + 1];
    if (!nx) return '';
    if (nx === 'review') return 'Review';
    var f = x.face(nx); return f ? f.label : 'next step';
  }

  function ensureBar(m) {
    if (bar && bar.isConnected && m.contains(bar)) return bar;
    var foot = m.querySelector('.lkp2__mfoot') || m.querySelector('.lkp2__dialog');
    bar = document.createElement('div');
    bar.className = 'lkp2-auto'; bar.hidden = true; bar.setAttribute('role', 'status');
    bar.innerHTML = '<span class="lkp2-auto__t">&#10003; Done &ndash; taking you to <b></b></span>' +
      '<button type="button" class="lkp2-auto__stay">Stay here</button><i class="lkp2-auto__bar"></i>';
    foot.insertBefore(bar, foot.firstChild);
    return bar;
  }
  function cancel() {
    if (timer) { clearTimeout(timer); timer = null; }
    if (bar) bar.hidden = true;
  }
  function advance(x) {
    cancel();
    var st = x.steps(), i = st.indexOf(x.st.step);
    if (i < 0 || i >= st.length - 1) return;
    x.stepBy(1);
    setTimeout(function () { focusFirst(x); }, 60);
  }
  // 24/10/2026: nothing moves on by itself any more - the customer is always in control.
  // When a step is complete, the Next button is outlined in gold and pulses once.
  function schedule(x) {
    var m = modal(); if (!m) return;
    cancel();
    var nb = m.querySelector('[data-act="next"]'); if (!nb) return;
    clearMark();
    nb.classList.add('lkp2-auto-next'); nb.classList.remove('lkp2-auto-ready'); void nb.offsetWidth; nb.classList.add('lkp2-auto-ready');
  }
  function pulse(el) {
    if (!el) return;
    el.classList.remove('lkp2-auto-need'); void el.offsetWidth; el.classList.add('lkp2-auto-need');
    setTimeout(function () { el.classList.remove('lkp2-auto-need'); }, 1600);
  }
  function guideFinish(m, x) {
    if (!x.colourIsVariant && (x.cfg.colours || []).length > 1 && !x.colour()) return mark(m.querySelector('.lkp2__colours'));
    mark(m.querySelector('.lkp2__pick'));
  }
  // "Next" highlight: a gold outline that stays on the next thing to choose or fill in until it is used
  function clearMark() { Array.prototype.forEach.call(document.querySelectorAll('.lkp2-auto-next'), function (e) { e.classList.remove('lkp2-auto-next'); }); }
  function mark(el) {
    clearMark();
    if (!el || el.offsetParent === null) return;
    el.classList.add('lkp2-auto-next');
    pulse(el);
  }
  function markFirst(m, x) {
    if (!m || !x || !x.st) return;
    if (x.st.step === 'finish') {
      var units = finishUnits(m), keys = units.map(keyOf);
      for (var i = 0; i < units.length; i++) if (!touched[keys[i]]) return mark(units[i]);
      return clearMark();
    }
    if (x.st.step === 'review') return clearMark();
    var e = firstEmpty(openPanel(m)); if (e) mark(e); else clearMark();
  }
  // First step (options): the controls are worked through top to bottom. Only move on once the customer has
  // used the last control, or has already been through every control below the one just used; otherwise
  // point them at the next control instead (e.g. sides -> box -> colour on the tie clip).
  // Units are remembered by a key, not by element: the engine redraws the step after most clicks.
  var touched = {};
  function finishSec(m) { return m && m.querySelector('.lkp2__sec--finish'); }
  function unitOf(el) {
    return el.closest('.lkp2__colours') || el.closest('.lkp2__pick') || (el.tagName === 'SELECT' ? el : el.parentElement);
  }
  function keyOf(u) {
    if (!u) return '';
    if (u.classList.contains('lkp2__colours')) return 'colours';
    if (u.classList.contains('lkp2__pick')) return 'pick';
    if (u.tagName === 'SELECT') { // by position: option labels (prices) change when the engine redraws
      var sec = u.closest('.lkp2__sec--finish'), all = sec ? Array.prototype.slice.call(sec.querySelectorAll('select')) : [];
      return 'sel:' + all.indexOf(u);
    }
    var b = u.querySelector('button'); return 'grp:' + (b ? b.className.split(' ')[0] : u.className);
  }
  function finishUnits(m) {
    var sec = finishSec(m), seen = [], out = [];
    if (!sec) return out;
    Array.prototype.forEach.call(sec.querySelectorAll('button,select'), function (c) {
      if (c.disabled || c.offsetParent === null || c.closest('.lkp2-auto')) return;
      var u = unitOf(c); if (u && seen.indexOf(u) < 0) { seen.push(u); out.push(u); }
    });
    return out;
  }
  function afterFinish(m, x, key) {
    markReady(m, x);
    var units = finishUnits(m), keys = units.map(keyOf), i = keys.indexOf(key);
    if (!key || i < 0) return; // hidden helper control (e.g. a variant select changed by a button): the button click decides
    touched[key] = 1;
    for (var k = i + 1; k < units.length; k++) {
      if (!touched[keys[k]]) { mark(units[k]); return; }
    }
    clearMark();
    // 24/10/2026: the options step never moves on by itself (customers like to look at each colour first):
    // once everything is chosen, the Next button is outlined in gold instead
    if (finishDone(x)) { var nb = m.querySelector('[data-act="next"]'); if (nb) { nb.classList.add('lkp2-auto-next'); nb.classList.remove('lkp2-auto-ready'); void nb.offsetWidth; nb.classList.add('lkp2-auto-ready'); } }
    else guideFinish(m, x);
  }
  function textBoxes(p) {
    return p ? Array.prototype.filter.call(p.querySelectorAll('input[type=text],input:not([type]),input[type=tel],input[type=email],input[type=url],input[type=date],input[type=time],textarea'),
      function (i) { return !i.disabled && i.offsetParent !== null; }) : [];
  }
  function firstEmpty(p) { var t = textBoxes(p); for (var i = 0; i < t.length; i++) if (!t[i].value) return t[i]; return null; }
  function focusFirst(x) {
    var m = modal(); decorate(m, x); markFirst(m, x);
  }
  function markReady(m, x) {
    var n = m && m.querySelector('[data-act="next"]'); if (!n) return;
    n.classList.toggle('lkp2-auto-ready', !!(x && stepDone(x)));
  }
  function decorate(m, x) {
    if (!m) return;
    textBoxes(openPanel(m)).forEach(function (i) { if (i.tagName === 'INPUT') i.setAttribute('enterkeyhint', 'next'); });
    markReady(m, x);
  }

  // Keep the timer honest when the customer moves between steps themselves.
  var go0 = P.prototype.goStep;
  P.prototype.goStep = function () {
    if (timer && this.st && this.st.step !== fromStep) cancel();
    var r = go0.apply(this, arguments);
    var x = this; setTimeout(function () { var m = modal(); decorate(m, x); markFirst(m, x); }, 0);
    return r;
  };

  document.addEventListener('click', function (ev) {
    var m = modal(); if (!m || !m.contains(ev.target)) return;
    var t = ev.target;
    if (t.closest('.lkp2-auto__stay')) { cancel(); return; }
    if (t.closest('[data-act],.lkp2__step,.lkp2__x,.lkp2__zoom,.lkp2__ynbtn')) { cancel(); return; }
    var x = me(); if (!x || !x.st) return;
    var step = x.st.step;
    if (step === 'finish') {
      var sec = finishSec(m), hit = sec && sec.contains(t) && t.closest('button');
      cancel();
      if (!hit) return;
      if (hit.closest('.lkp2__pick')) x._autoChips = true; // the customer has looked at the sides
      var hk = finishUnits(m).indexOf(unitOf(hit)) >= 0 ? keyOf(unitOf(hit)) : ''; // read before the engine redraws
      setTimeout(function () { afterFinish(m, x, hk); }, 80);
      return;
    }
    if (step === 'review') return;
    var p = openPanel(m);
    var choice = p && p.contains(t) && t.closest('button,label,input[type=radio],input[type=checkbox],[role=option],[role=radio]');
    cancel();
    if (!choice || choice.closest('.lkp2__font,.lkp2__fontdd,summary,details > summary') || /^(INPUT)$/.test(choice.tagName) && !/radio|checkbox/.test(choice.type)) return;
    setTimeout(function () {
      var f = curFace(x); markReady(m, x);
      if (faceDone(x, f)) { clearMark(); schedule(x); }
      else { var e = firstEmpty(openPanel(m)); mark(e); }
    }, 80);
  }, true);

  document.addEventListener('change', function (ev) {
    var m = modal(); if (!m || !m.contains(ev.target) || ev.target.tagName !== 'SELECT') return;
    var x = me(); if (!x || !x.st) return;
    var sk = ev.target.offsetParent !== null ? keyOf(ev.target) : '';
    cancel();
    setTimeout(function () {
      markReady(m, x);
      if (x.st.step === 'finish') { afterFinish(m, x, sk); return; }
      if (x.st.step !== 'review' && faceDone(x, curFace(x))) schedule(x);
    }, 120);
  }, true);

  document.addEventListener('keydown', function (ev) {
    var m = modal(); if (!m || !m.contains(ev.target)) return;
    var t = ev.target, x = me(); if (!x || !x.st) return;
    if (ev.key !== 'Enter') { if (timer && /INPUT|TEXTAREA|SELECT/.test(t.tagName)) cancel(); return; }
    if (t.tagName !== 'INPUT' || /checkbox|radio|button|submit/.test(t.type)) return;
    var p = openPanel(m); if (!p || !p.contains(t)) return;
    ev.preventDefault();
    var boxes = textBoxes(p), i = boxes.indexOf(t);
    for (var k = i + 1; k < boxes.length; k++) { if (!boxes[k].value) { mark(boxes[k]); boxes[k].focus(); return; } }
    try { t.blur(); } catch (e) {}
    if (faceDone(x, curFace(x))) schedule(x); else mark(firstEmpty(p));
  }, true);

  document.addEventListener('input', function (ev) {
    var m = modal(); if (!m || !m.contains(ev.target)) return;
    if (timer) cancel();
    if (ev.target.classList && ev.target.classList.contains('lkp2-auto-next')) ev.target.classList.remove('lkp2-auto-next');
    var x = me(); setTimeout(function () { markReady(m, x); }, 60);
  }, true);

  document.addEventListener('focusin', function (ev) {
    var m = modal(); if (!m || !m.contains(ev.target)) return;
    if (/INPUT|TEXTAREA/.test(ev.target.tagName)) { focusVal = ev.target.value; if (timer) cancel(); }
  }, true);

  document.addEventListener('focusout', function (ev) {
    var m0 = modal(), x0 = me();
    if (m0 && x0 && x0.st && x0.st.step === 'finish' && ev.target.tagName === 'SELECT' && finishSec(m0) && finishSec(m0).contains(ev.target) && ev.target.offsetParent !== null && !touched[keyOf(ev.target)]) {
      var sel = ev.target, fk = keyOf(sel); setTimeout(function () { if (!touched[fk] && document.activeElement !== sel) afterFinish(m0, x0, fk); }, 150);
    }
    var m = modal(), t = ev.target; if (!m || !m.contains(t) || !/INPUT|TEXTAREA/.test(t.tagName)) return;
    var changed = t.value !== focusVal, x = me(); if (!x || !x.st || !changed) return;
    var p = openPanel(m); if (!p || !p.contains(t)) return;
    setTimeout(function () {
      var a = document.activeElement;
      if (a && p.contains(a) && /INPUT|TEXTAREA|SELECT/.test(a.tagName)) return; // still filling this step
      if (modal() && faceDone(x, curFace(x)) && !firstEmpty(p)) { clearMark(); schedule(x); }
      else if (modal() && firstEmpty(p)) mark(firstEmpty(p));
    }, 250);
  }, true);

  var css = document.createElement('style');
  css.textContent =
    '.lkp2-auto{position:relative;display:flex;align-items:center;justify-content:space-between;gap:10px;margin:0 0 8px;padding:9px 12px;border-radius:8px;background:#f3efe6;color:#3b3326;font-size:14px;overflow:hidden}' +
    '.lkp2-auto[hidden]{display:none}' +
    '.lkp2-auto__stay{background:none;border:0;padding:4px 2px;font:inherit;font-size:13px;text-decoration:underline;color:#3b3326;cursor:pointer;white-space:nowrap}' +
    '.lkp2-auto__bar{position:absolute;left:0;bottom:0;height:3px;width:100%;background:#a8823a;transform-origin:left;transform:scaleX(0)}' +
    '.lkp2-auto.is-go .lkp2-auto__bar{animation:lkp2AutoFill ' + DELAY + 'ms linear forwards}' +
    '@keyframes lkp2AutoFill{to{transform:scaleX(1)}}' +
    '.lkp2-auto-need{animation:lkp2AutoNeed 1.4s ease}' +
    '@keyframes lkp2AutoNeed{0%,100%{box-shadow:0 0 0 0 rgba(168,130,58,0)}30%{box-shadow:0 0 0 4px rgba(168,130,58,.45)}}' +
    '[data-act="next"].lkp2-auto-ready{animation:lkp2AutoReady 1.6s ease 1}' +
    '.lkp2-auto-next{outline:2px solid #a8823a!important;outline-offset:4px;border-radius:8px}' +
    '@keyframes lkp2AutoReady{0%{box-shadow:0 0 0 0 rgba(168,130,58,.6)}70%{box-shadow:0 0 0 10px rgba(168,130,58,0)}100%{box-shadow:none}}';
  document.head.appendChild(css);
})();
